import UnassignPropertyFromPortfolioModal from "./UnassignPropertyFromPortoflioModalContainer";

export default UnassignPropertyFromPortfolioModal;
